import Axios from 'axios';
import { makeApiRequest } from '../hooks/useRequestState';
import { authenticationBaseUrl } from '../../apollo/client';

export const verifyConfirmationCode = (
  email: string,
  verificationCode: string
) => {
  const httpRequest = Axios.post(authenticationBaseUrl, {
    type: 'verifyConfirmationCode',
    email,
    verificationCode
  });
  return makeApiRequest<unknown>(httpRequest);
};

export const resendConfirmationCode = (email: string) => {
  const httpRequest = Axios.post(authenticationBaseUrl, {
    type: 'resendConfirmationCode',
    email
  });
  return makeApiRequest<unknown>(httpRequest);
};

export const resetPassword = (email: string) => {
  const httpRequest = Axios.post(authenticationBaseUrl, {
    type: 'forgotPassword',
    email
  });
  return makeApiRequest<unknown>(httpRequest);
};
